import React from 'react'

import CircleLeftIcon from '../../icons/CircleLeftIcon'

import { useBreakpoint } from '../../../providers/BreakpointProvider'
import useStyles, { ANIMATION_DELAY } from './styles'

const SidePanel = ({
  title,
  toggleView,
  subComponent,
  narrow,
  bottomNavHeight = 0,
  absoluteTitle = false,
  children
}) => {
  const { isSmall } = useBreakpoint()

  const [open, setOpen] = React.useState(true)

  // Offset from open state to help with animation smoothness
  const [showContent, setShowContent] = React.useState(true)
  const [fullyClosed, setFullyClosed] = React.useState(false)

  const classes = useStyles({
    open,
    isSmall,
    fullyClosed,
    showContent,
    hasSubcomponent: !!subComponent,
    narrow,
    bottomNavHeight,
    absoluteTitle
  })

  // Delay content being shown when opening
  React.useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        setShowContent(true)
      }, ANIMATION_DELAY / 2)

      return () => {
        clearTimeout(timer)
      }
    }
  }, [open])

  const handleToggle = React.useCallback(() => {
    if (open) {
      // Hide content immediately
      setShowContent(false)

      // Wait for animation to finish
      setTimeout(() => {
        setFullyClosed(true)
      }, ANIMATION_DELAY)
    } else {
      setFullyClosed(false)
    }

    setOpen(old => !old)
    toggleView && toggleView()
  }, [open, toggleView])

  return (
    <div className={classes.root}>
      {showContent && <div className={classes.title}>{title}</div>}

      {showContent && !!subComponent && (
        <div className={classes.bottomBorder}>{subComponent}</div>
      )}

      <CircleLeftIcon
        data-testid='open-close-button'
        onClick={handleToggle}
        className={classes.button}
      />

      {showContent && <div className={classes.children}>{children}</div>}
    </div>
  )
}

export default SidePanel
